import { getDataMapper, mapField } from "@/shared";

export const mapRequisitesCompanyFromServer = getDataMapper({
    title: mapField("title"),
    inn: mapField("inn"),
    kpp: mapField("kpp"),
    ogrn: mapField("ogrn"),
    address: mapField("address"),
    bankName: mapField("bank_name"),
    bic: mapField("bic"),
    checkingAccount: mapField("checking_account"),
});
